import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Auth from "../Features/Authentication/View/Auth";
import ResetPassword from "../Features/Authentication/View/ResetPassword";
import Dashboard from "../Features/Dashboard/View/Dashboard";
import CompleteProfile from "../Features/Profile/View/CompleteProfile";
import Profile from "../Features/Profile/View/Profile";
import GroupRoom from "../Features/Session/View/GroupRoom";
import Breakout from "../Features/Session/View/Breakout";
import Lobby from "../Features/IntelliMe/View/Lobby";
import Questions from "../Features/IntelliMe/View/Questions";
import VirtualRoom from "../Features/IntelliMe/View/VirtualRoom";
import BreakoutRoom from "../Features/IntelliMe/View/BreakoutRoom";
import PreBreakoutEvaluation from "../Features/IntelliMe/View/PreBreakoutEvaluation";
import PostBreakoutEvaluation from "../Features/IntelliMe/View/PostBreakoutEvaluation";
import CoachingModule from "../Features/IntelliMe/View/CoachingModule";
import SearchingSessions from "../Features/IntelliMe/View/SearchingSessions";
// FuntelliMe imports
import ModeSelection from "../Features/FuntelliMe/View/ModeSelection";
import TextChatLobby from "../Features/FuntelliMe/View/TextChatLobby";
import DynamicProfiles from "../Features/FuntelliMe/View/DynamicProfiles";
import TextChat from "../Features/FuntelliMe/View/TextChat";
import EndInteraction from "../Features/FuntelliMe/View/EndInteraction";
import VideoLobby from "../Features/FuntelliMe/View/VideoLobby";
import VideoProfiles from "../Features/FuntelliMe/View/VideoProfiles";
import VideoRoom from "../Features/FuntelliMe/View/VideoRoom";
// ✅ Protected Route wrapper
function PrivateRoute({ children }) {
  const isAuthenticated = localStorage.getItem("isLoggedIn"); 
  // or use Firebase's auth state listener if you prefer
  return isAuthenticated ? children : <Navigate to="/auth" />;
}
export default function AppRoutes() {
  return (
    <Routes>
      {/* Auth route handles both login & signup */}
      {/* Add key to force remount on path change */}
      <Route path="/auth" element={<Auth key={window.location.pathname} />} />
      {/* Password reset route */}
      <Route path="/reset-password" element={<ResetPassword />} />
      {/* Profile completion route */}
      <Route path="/complete-profile" element={<CompleteProfile />} />
      {/* Profile route */}
      <Route path="/profile" element={<Profile />} />
      {/* Protected dashboard */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      {/* GroupRoom route (session group view) */}
      <Route
        path="/group/:id"
        element={
          <PrivateRoute>
            <GroupRoom />
          </PrivateRoute>
        }
      />
            {/* Breakout route (pair breakout view) */}
            <Route
              path="/breakout/:pairId"
              element={
                <PrivateRoute>
                  <Breakout />
                </PrivateRoute>
              }
            />
            {/* IntelliMe Lobby route */}
            <Route
              path="/lobby/:sessionId"
              element={
                <PrivateRoute>
                  <Lobby />
                </PrivateRoute>
              }
            />
            {/* IntelliMe Virtual Room route */}
            <Route
              path="/virtual-room/:sessionId"
              element={
                <PrivateRoute>
                  <VirtualRoom />
                </PrivateRoute>
              }
            />
            {/* IntelliMe Pre-Breakout Evaluation route */}
            <Route
              path="/pre-breakout-evaluation/:sessionId"
              element={
                <PrivateRoute>
                  <PreBreakoutEvaluation />
                </PrivateRoute>
              }
            />
            {/* IntelliMe Breakout Room route */}
            <Route
              path="/breakout-room/:sessionId"
              element={
                <PrivateRoute>
                  <BreakoutRoom />
                </PrivateRoute>
              }
            />
            {/* IntelliMe Post-Breakout Evaluation route */}
            <Route
              path="/post-breakout-evaluation/:sessionId"
              element={
                <PrivateRoute>
                  <PostBreakoutEvaluation />
                </PrivateRoute>
              }
            />
            {/* IntelliMe Coaching Module route */}
            <Route
              path="/coaching/:sessionId"
              element={
                <PrivateRoute>
                  <CoachingModule />
                </PrivateRoute>
              }
            />
            {/* IntelliMe Questions route */}
            <Route
              path="/questions/:pairId"
              element={
                <PrivateRoute>
                  <Questions />
                </PrivateRoute>
              }
            />
            {/* Sessions Searching for a Pair */}
            <Route
              path="/sessions-searching"
              element={
                <PrivateRoute>
                  <SearchingSessions />
                </PrivateRoute>
              }
            />
            {/* FuntelliMe Routes */}
            <Route
              path="/funtellime/mode-selection"
              element={
                <PrivateRoute>
                  <ModeSelection />
                </PrivateRoute>
              }
            />
            <Route
              path="/funtellime/text-lobby"
              element={
                <PrivateRoute>
                  <TextChatLobby />
                </PrivateRoute>
              }
            />
            <Route
              path="/funtellime/profiles/:chatId"
              element={
                <PrivateRoute>
                  <DynamicProfiles />
                </PrivateRoute>
              }
            />
            <Route
              path="/funtellime/chat/:chatId"
              element={
                <PrivateRoute>
                  <TextChat />
                </PrivateRoute>
              }
            />
            <Route
              path="/funtellime/end/:chatId"
              element={
                <PrivateRoute>
                  <EndInteraction />
                </PrivateRoute>
              }
            />
            <Route
              path="/funtellime/video-lobby"
              element={
                <PrivateRoute>
                  <VideoLobby />
                </PrivateRoute>
              }
            />
            <Route
              path="/funtellime/video-profiles/:sessionId"
              element={
                <PrivateRoute>
                  <VideoProfiles />
                </PrivateRoute>
              }
            />
            <Route
              path="/funtellime/video-room/:sessionId"
              element={
                <PrivateRoute>
                  <VideoRoom />
                </PrivateRoute>
              }
            />
            <Route
              path="/funtellime/video-end/:sessionId"
              element={
                <PrivateRoute>
                  <EndInteraction />
                </PrivateRoute>
              }
            />
            {/* Default redirect to /auth */}
            <Route path="*" element={<Navigate to="/auth" />} />
          </Routes>
        );
      }
